module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/mv_photowedding_04@3x-ad8b85baf34b4573a704ad8de2bae1db.webp";